<template>
  <article class="c-card">
    <header class="c-card__header">
      <div class="c-card__leading">
        <h6 class="c-card__title">{{ definitionModule.name }}</h6>
        <span class="meta">{{ $t(definitionModule.type).label }}</span>
      </div>
      <div class="c-card__control">
        <button @click="installModule" href="#" :disabled="definitionModule.module || installing" v-bind:class="buttonClass" class="btn btn--smart btn--sm">
          {{ definitionModule.module ? 'Instalado' : 'Instalar' }}
        </button>
      </div>
    </header>
  </article>
</template>

<script>
  import { mapActions } from 'vuex'
  import notifier from '../../notifier'

  export default {
    data: () => ({
      installing: false
    }),
    props: {
      definitionModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions('module', [
        'install'
      ]),
      async installModule () {
        this.installing = true

        try {
          await this.install(this.definitionModule)
          notifier.success('Módulo instalado com sucesso!', 'Instalado')
        } catch (err) {
          notifier.error('Falha ao instalar o módulo, tente novamente mais tarde.', 'Não instalado')
        }

        this.installing = false
      }
    },
    computed: {
      buttonClass () {
        return {
          'is-loading': this.installing,
          'btn--success': !this.definitionModule.module,
          'btn--default': this.definitionModule.module
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// StoreCardTool.vue?3e178a30